{"domain":"shop.nestingale.com","storefrontAccessToken":"aacf6bb4a693f1477688cb1098928f9b","adminDomain":"nestingaleecommerce.myshopify.com"}